import resetStyles from './reset-styles';
import additionalEditorStyles from './additional-editor-styles';
import setupBaseURL from './setup-base-url';
import injectDriver from './inject-driver';
import injectEditorFont from './inject-editor-font';
import reviveIOSEventPropagation from './ios-workarounds/revive-event-propagation';
import injectIOSMarker from './ios-workarounds/inject-ios-marker';
import injectIOSInitialContainer from './ios-workarounds/inject-inital-container';
import removeLazyLoadingAttributeFromImages from '../../utils/helpers/webkit-workarounds/remove-lazy-loading-attribute-from-images';

const withIFrameAdditives = (liveDOM) => {
  setupBaseURL(liveDOM);
  resetStyles(liveDOM);
  additionalEditorStyles(liveDOM);
  injectEditorFont(liveDOM);
  injectDriver(liveDOM);
  injectIOSInitialContainer(liveDOM);
  reviveIOSEventPropagation(liveDOM);
  injectIOSMarker(liveDOM);
  removeLazyLoadingAttributeFromImages(liveDOM);
};

export default withIFrameAdditives;
